import { defineMessage } from 'react-intl';

export const defaultLocale = 'en';

export const SUPPORTED_LOCALES = ['en', 'no', 'fr', 'zh', 'dk'];

const localeToMomentLocalesMap = {
  en: 'en',
  no: 'nb',
  fr: 'fr',
  zh: 'zh',
  dk: 'dk',
};

export const localesIntl = {
  dk: defineMessage({
    id: 'LocaleSelect-img-dkFlag',
    defaultMessage: 'Danish',
  }),
  en: defineMessage({
    id: 'LocaleSelect-img-enFlag',
    defaultMessage: 'English',
  }),
  fr: defineMessage({
    id: 'LocaleSelect-img-frFlag',
    defaultMessage: 'French',
  }),
  no: defineMessage({
    id: 'LocaleSelect-img-noFlag',
    defaultMessage: 'Norwegian',
  }),
  zh: defineMessage({
    id: 'LocaleSelect-img-zhFlag',
    defaultMessage: 'Chinese',
  }),
};

export const getMomentLocaleFromLocale = locale => localeToMomentLocalesMap[locale];
